import { addresses } from "../config/contracts";

const ZERO = "0x0000000000000000000000000000000000000000";

export default function Footer() {
  const isTestnet = Number(import.meta.env.VITE_CHAIN_ID ?? 84532) === 84532;
  const explorer = isTestnet ? "https://sepolia.basescan.org/address/" : "https://basescan.org/address/";

  const cols = [
    {
      title: "Token",
      links: [
        { label: "Tokenomics", href: "#tokenomics" },
        { label: "Whitepaper", href: "#" },
        { label: "Presale", href: "#presale" },
        { label: "Staking", href: "#staking" },
      ],
    },
    {
      title: "Build",
      links: [
        { label: "GitHub", href: "https://github.com/FANZ-Group/FanzCoin" },
        { label: "Audits", href: "#trust" },
        { label: "Brand kit", href: "#" },
        { label: "Docs", href: "https://docs.fanz.website" },
      ],
    },
    {
      title: "Network",
      links: [
        { label: "BoyFanz", href: "https://boyfanz.com" },
        { label: "GirlFanz", href: "https://girlfanz.com" },
        { label: "GayFanz", href: "https://gayfanz.com" },
        { label: "All platforms", href: "https://fanz.network" },
      ],
    },
    {
      title: "Connect",
      links: [
        { label: "X / Twitter", href: "https://x.com/fanzcoin" },
        { label: "Discord", href: "https://discord.gg/fanz" },
        { label: "Telegram", href: "https://t.me/fanzcoin" },
        { label: "support@fanzunlimited.com", href: "mailto:support@fanzunlimited.com" },
      ],
    },
  ];

  return (
    <footer className="relative mt-16 border-t border-white/[0.06]">
      <div className="ambient-grain pointer-events-none absolute inset-0 opacity-50" />

      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-gradient-to-br from-accent to-accent-deep">
                <span className="font-display text-3xl text-white">F</span>
              </div>
              <div>
                <div className="font-display text-3xl tracking-wide text-white">$FANZ</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-gray-300">
                  Creator Economy Token
                </div>
              </div>
            </div>
            <p className="mt-4 max-w-sm text-sm text-gray-300">
              The on-chain settlement layer for FANZ Unlimited Network — 25 platforms,
              one money plane, zero creator fees. Audited contracts on Base.
            </p>
            <div className="mt-5 space-y-1.5 text-xs">
              <div className="font-mono text-gray-300">
                Token: {addresses.token === ZERO ? "—" : (
                  <a className="text-accent hover:underline" href={`${explorer}${addresses.token}`} target="_blank" rel="noreferrer">
                    {short(addresses.token)}
                  </a>
                )}
              </div>
              <div className="font-mono text-gray-300">
                Presale: {addresses.presale === ZERO ? "—" : (
                  <a className="text-accent hover:underline" href={`${explorer}${addresses.presale}`} target="_blank" rel="noreferrer">
                    {short(addresses.presale)}
                  </a>
                )}
              </div>
              <div className="font-mono text-gray-300">
                Staking: {addresses.staking === ZERO ? "—" : (
                  <a className="text-accent hover:underline" href={`${explorer}${addresses.staking}`} target="_blank" rel="noreferrer">
                    {short(addresses.staking)}
                  </a>
                )}
              </div>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/40">{c.title}</div>
              <ul className="mt-3 space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      target={l.href.startsWith("http") ? "_blank" : undefined}
                      rel="noreferrer noopener"
                      className="text-sm text-gray-300 transition-colors hover:text-white"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/[0.06] pt-6 text-xs text-gray-300 md:flex-row md:items-center">
          <div>
            &copy; 2026 FANZ Unlimited Network LLC. Not financial advice. Adults 18+ only.
          </div>
          <div className="font-mono text-white/40">
            v0.2 · Build {Number(Date.now() / 1000).toFixed(0)}
          </div>
        </div>
      </div>
    </footer>
  );
}

function short(addr: string) {
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}
